"use strict";

/**
|--------------------------------------------------
| Datepicker - Dynamic Import
|--------------------------------------------------
*/

import { safelyParseJSON } from '../core.js';
export const initDatepicker = async (selector) => {
    const inputs = document.querySelectorAll(selector);
    if (inputs.length === 0) return;
    try {
        const [DatepickerModule] = await Promise.all([
            import('vanillajs-datepicker')
        ]);
        const Datepicker = DatepickerModule.Datepicker;

        // Ensure the class was loaded correctly
        if (!Datepicker) {
            console.error("Could not find 'Datepicker' class in the loaded module.");
            return;
        }
        inputs.forEach(input => {
            const defaultConfig = {
                buttonClass: 'btn',
                format: 'dd/mm/yyyy',
                weekStart: 1,
                autohide: true
            }
            let config = defaultConfig;
            if(input.dataset.config){
                config = safelyParseJSON(input.dataset.config, defaultConfig);
            }
    
            if(config.days) Datepicker.locales.en.days = config.days;
            if(config.daysShort) Datepicker.locales.en.daysShort = config.daysShort;
            if(config.daysMin) Datepicker.locales.en.daysMin = config.daysMin;
            if(config.months) Datepicker.locales.en.months = config.months;
            if(config.monthsShort) Datepicker.locales.en.monthsShort = config.monthsShort;
            if(config.format) Datepicker.locales.en.format = config.format;
            if(config.weekStart) Datepicker.locales.en.weekStart = config.weekStart;

            try {
                new Datepicker(input, config);
            } catch (initError) {
                 console.error("Error initializing Datepicker for input:", input, initError);
            }
        });

    } catch (error) {
        console.error("Failed to dynamically load Datepicker library:", error);
    }
};